import MentoringMain from './MentoringMain.vue';

export default MentoringMain;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/requestcard/components/main/index.ts